import { render, staticRenderFns } from "./FilePreview.vue?vue&type=template&id=c40b9ef0&scoped=true&"
import script from "./FilePreview.vue?vue&type=script&lang=js&"
export * from "./FilePreview.vue?vue&type=script&lang=js&"
import style0 from "./FilePreview.vue?vue&type=style&index=0&id=c40b9ef0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c40b9ef0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/user/workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c40b9ef0')) {
      api.createRecord('c40b9ef0', component.options)
    } else {
      api.reload('c40b9ef0', component.options)
    }
    module.hot.accept("./FilePreview.vue?vue&type=template&id=c40b9ef0&scoped=true&", function () {
      api.rerender('c40b9ef0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FileExplorer/FilePreview.vue"
export default component.exports